import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetManagementService, CardType } from '../asset-management-service';
import { LoaderService } from '@app/shared/services/loader.service';

@Component({
  selector: 'app-asset-management-dashboard',
  templateUrl: './asset-management-dashboard.component.html',
  styleUrl: './asset-management-dashboard.component.scss',
})
export class AssetManagementDashboardComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly assetManagementService: AssetManagementService,
    private readonly loaderService: LoaderService,
  ) {
    this.loaderService.hide();
  }

  ngOnInit(): void {
    this.assetManagementService.preloadAccessoriesData().catch(error => {
      console.warn('Failed to preload accessories data:', error);
    });
  }

  navigateToMyRequests(): void {
    localStorage.setItem('selectedCard', 'My-Request');
    this.router.navigate(['/asset-management/my-request']).then(result => {
    }).catch(error => {
    });
  }

  navigateToOnboarding(): void {
    localStorage.setItem('selectedCard', 'onboarding');
    this.router.navigate(['/asset-management/upcoming-onboarding']).then(result => {
    }).catch(error => {
    });
  }

  navigateToOffboarding(): void {
    localStorage.setItem('selectedCard', 'offboarding');
    this.router.navigate(['/asset-management/upcoming-offboarding']).then(result => {
    }).catch(error => {
    });
  }

  navigateToAssetAllocated(): void {
    localStorage.setItem('selectedCard', 'asset-allocated');
    this.router.navigate(['/asset-management/asset-allocated']).then(result => {
    }).catch(error => {
    });
  }
}
